import React from "react";
import PublicPageLayout from "./PublicPageLayout";
import AboutContent from "../Common/AboutContent";

/**
 * PublicAbout - About page wrapper for public/unauthenticated users
 * Uses PublicPageLayout for header/footer and AboutContent for the actual content
 */
const PublicAbout = () => {
    return (
        <PublicPageLayout>
            <AboutContent />
        </PublicPageLayout>
    );
};

export default PublicAbout;
